export default {
  key: "succes",
  Things: "Dingen",
  "Upload Date": "Upload datum",
  Duration: "Looptijd",
  Features: "Functies",
  "Edit Image": "Bewerk afbeelding",
  Title: "Titel",
  Description: "Beschrijving",
  "New Image": "Nieuw beeld",
  Image: "Afbeelding",
  Images: "Afbeeldingen",
  Tags: "Tags",
  "Save & close": "Opslaan & sluiten",
  Type: "Type",
  Edit: "Bewerk",
  Delete: "Verwijderen",
  "Go back": "Ga terug",
  "New item": "Nieuw item",
  Id: "Id",
  "Upload Image": "Afbeelding uploaden",
  "Layouts Timeline": "Tijdlijn van lay-outs",
  Date: "Datum",
  "Back stage": "Achter het podium",
  Front: "Voorkant",
  items: "artikelen",
  "Navigate: Things": "Navigeren: Dingen",
  Orientation: "oriëntatie",
  back: "rug",
  front: "voorkant",
  gallery: "galerij",
  preview: "voorbeeld",
  New: "Nieuw",
  search: "zoeken",
};
